var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-select',_vm._g(_vm._b({ref:"select",attrs:{"prop":_vm.prop,"api":_vm.api,"get-label":_vm.getLabel,"lazy-load":_vm.lazyLoad}},'search-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }